<div class="home-container">
  <app-resource-catalogue ></app-resource-catalogue>
</div>
